import "./propertyComparer.js";
import "./converter.js";
import { EditorPropertyDecorations } from "./propertyProvider.actions.js";
import { ILogService } from "../../log/common/log.js";
import { IFileService } from "../../files/common/files.js";
import { IPropertyService } from "../../properties/common/properties.js";
import { IPropertyAccessorService } from "../../properties/common/accessor.js";
import { IStorageService } from "../../storage/common/storage.js";
import { PropertyStateProviderGroup, ViewModePropertyStateProvider } from "../../properties/common/propertyService.js";
import { PropertyViewMode } from "../../properties/common/properties.js";
import { ILicenseService } from "../../auth/common/licenses.js";
import type { ThreeJs } from "./webgl.js";
import { ThreeDefaultViewMode } from "./propertyProvider.viewmode.js";
import { ThreePropertyReader } from "./propertyReader.js";

export { Needle, isEventListValue } from "./propertyReader.js";

/** Editor registration supplies persistence and editor-only actions to the shared reader. */
export class ThreePropertyProvider extends ThreePropertyReader {
    constructor(
        engine: ThreeJs,
        @ILogService logger: ILogService,
        @IFileService _fileService: IFileService,
        @IPropertyService _propertyService: IPropertyService,
        @IPropertyAccessorService accessors: IPropertyAccessorService,
        @IStorageService storage: IStorageService,
        @ILicenseService license: ILicenseService,
    ) {
        super(logger, accessors, options => new PropertyStateProviderGroup(
            options.viewMode === PropertyViewMode.DEFAULT ? new ThreeDefaultViewMode() : null,
            new ViewModePropertyStateProvider(options.viewMode, storage),
        ), engine, new EditorPropertyDecorations(engine, license));
    }
}
